import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   */
  fetchDashboardCardDetails: (query: QueryParameters): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/super-admin/v2/dashboard/total-dashboard-cards`, {
      ...query,
    });
  },
  /**
   * Fetch the all charging station list location in map
   */
  fetchAllChargingStationList: (query: QueryParameters): Promise<any> => {
    return getRequest(
      `${config.commonApiUrl}api/super-admin/v1/charging-station/charging-stations-map`,
      { ...query },
    );
  },
  /**
   * Fetch the all charging station list location in map
   */
  getChargingStationDetails: (id: string): Promise<any> => {
    return getRequest(
      `${config.commonApiUrl}api/super-admin/v1/charging-station/charging-stations-map/${id}`,
      {},
    );
  },
  /**
   * Fetch the all charging station list location in map
   */
  getRevenueAndPowerConsumedDetails: (type: string, stationId: string = ''): Promise<any> => {
    const request: any = { type };
    if (stationId) {
      request.stationId = stationId;
    }
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction/revenue-and-power-consumed-details`,
      request,
    );
  },
  // Cards data
  /**
   * Fetch devices API
   * @param query
   */
  getConnectorCount: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/total-connectors`, {
      ...query,
    }),
  /**
   * Fetch devices API
   * @param query
   */
  getStationCount: (query: QueryParameters) =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-station/total-charging-stations`,
      { ...query },
    ),
  /**
   * Fetch devices API
   * @param query
   */
  getChargingPointCount: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/total-charging-points`, {
      ...query,
    }),
  /**
   * Fetch devices API
   * @param query
   */
  getDefectCount: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/total-faulted-connectors`, {
      ...query,
    }),
  /**
   * Fetch devices API
   * @param query
   */
  getConnectorStatusReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/connector-status-report`, {
      ...query,
    }),
  /**
   * Fetch devices API
   * @param query
   */
  getDeviceStatusReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/super-admin/v1/charging-point/device-status-report`, {
      ...query,
    }),
  /**
   * Fetch devices API
   * @param query
   */
  getAlertsReport: (query: QueryParameters) =>
    getRequest(`${config.reportApiUrl}api/facility/v1/charging-point/alerts-report`, { ...query }),
  /**
   * Fetch devices API
   * @param query
   */
  getScheduleChargingReport: (query: QueryParameters) =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/schedule-charging-confirmed-report`,
      {
        ...query,
      },
    ),
  /**
   * Fetch devices API
   * @param query
   */
  getStationPerformanceReport: (query: QueryParameters) =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/charging-point/station-performance-report`,
      {
        ...query,
      },
    ),
  /**
   * Fetch devices API
   * @param query
   */
  getDeviceActiveIdleReport: (query: QueryParameters) =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/device-active-idle-report`,
      {
        ...query,
      },
    ),
  /**
   * Fetch devices API
   * @param query
   */
  getDeviceUtilizationReport: (query: QueryParameters) =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/device-utilization-report`,
      {
        ...query,
      },
    ),
  /**
   * Fetch devices API
   * @param query
   */
  getPowerConsumedReport: (query: QueryParameters) =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/charging-transaction/power-consumption-report`,
      { ...query },
    ),
  /**
   * Fetch charging status
   * @returns
   */
  fetchChargingStatus: (query: QueryParameters) =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/total-device-status-report`,
      { ...query },
    ),
  /**
   * Fetch active charging point counts
   * @param query 
   * @returns 
   */
  getActiveChargingPointCounts: (query: QueryParameters) =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-point/total-active-device-count-report`,
      { ...query },
    ),

  /**
   * Create custom dashboard
   * @param data
   * @param isFileUpload
   * @returns
   */
  createCustomDashboard: (data: any = {}, isFileUpload = false): Promise<any> =>
    postRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard`,
      data,
      isFileUpload,
    ),
  /**
   * Get custom dashboard list
   * @param query
   * @returns
   */
  getCustomDashboardList: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard`,
      { ...query },
    ),
  /**
   * Delete custom dashboard
   * @param id
   * @returns
   */
  deleteCustomDashboard: (id: string): Promise<any> =>
    deleteRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/${id}`,
    ),
  /**
   * Get custom dashboard details by id
   * @param id
   * @returns
   */
  getCustomDashboardDetails: (id: string): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard/${id}`, {}),
  /**
   * Update custom dashboard
   * @param id
   * @param data
   * @param isFileUpload
   * @returns
   */
  updateCustomDashboard: (id: string, data: any = {}, isFileUpload = false): Promise<any> =>
    patchRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/${id}`,
      data,
      isFileUpload,
    ),
  /**
   * Get default custom dashboard
   * @returns
   */
  getDefaultCustomDashboard: (): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard/default`, {}),
  /**
   * Get penalty revenue
   * @param query
   * @returns
   */
  getPenaltyRevenue: (query: QueryParameters): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/dashboard/penalty-revenue-chart`, { ...query }),
  /**
   * Get station health score
   * @param query
   * @returns
   */
  getStationHealthScore: (query: QueryParameters): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/dashboard/station-health-score`, { ...query }),
};
